export default __webpack_public_path__ + "e908a557ddd88ef5ac29cd9b019f58e2.png";